import { render, staticRenderFns } from "./PhoneLayout.vue?vue&type=template&id=7f3a4947"
import script from "./PhoneLayout.vue?vue&type=script&lang=js"
export * from "./PhoneLayout.vue?vue&type=script&lang=js"
import style0 from "./PhoneLayout.vue?vue&type=style&index=0&id=7f3a4947&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports